export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAABPCAYAAAAjrA/vAAAAHklEQVQ4jWNgIAfUYxP8Pyo4KjgqOCo4KjgqSAQAAJNZSjb1eJ+PAAAAAElFTkSuQmCC"